import flatten from 'flat';
import app from './en-US/app';
import dashboard from './en-US/dashboard';
import date from './en-US/date';
import dpu from './en-US/dpu';
import menu from './en-US/menu';
import navBar from './en-US/navBar';
import tableContentView from './en-US/tableContentView';
import trigger from './en-US/trigger';
import promoBanner from './en-US/promoBanner';
import workspace from './en-US/workspace';
import emojiPicker from './en-US/emojiPicker';

export default flatten({
  ...app,
  ...dashboard,
  ...date,
  ...dpu,
  ...menu,
  ...navBar,
  ...tableContentView,
  ...trigger,
  ...promoBanner,
  ...workspace,
  ...emojiPicker,
});
